import { ICoordinate } from "shared/types";

export const MAP_STYLE = "mapbox://styles/tourmanagement/ckistjdoi1a3z1ao74m5jabrv";

export const DEFAULT_ZOOM = 0.6;
export const DEFAULT_FOCUS_ZOOM = 16;
export const DEFAULT_COORDINATES: ICoordinate = {
  longitude: 0,
  latitude: 20,
};
